import { userLogin, userLogout, accountInfo } from '@/api/modules/indexPage.js';
import { shareTree } from '@/api/modules/public.js';
import Cookies from 'js-cookie';

const actions = {
    systemList({ commit }, data = {}) {
        return new Promise((resolve, reject) => {
            systemList(data).then(
                res => {
                    commit('SET_MENU', res.data);
                    resolve(res);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    // 登录：兼容旧调用（仅传 username/password）与账号改造后的新调用
    // 新调用可传 userType('personal'|'enterprise') / loginMode('normal'|'root') / companyCode
    // 当传 account 时优先使用，否则用 username 兼容旧登录页
    login({ commit }, data = {}) {
        return new Promise((resolve, reject) => {
            const payload = {
                account: data.account || data.username,
                password: data.password
            }
            if (data.userType) payload.userType = data.userType
            if (data.loginMode) payload.loginMode = data.loginMode
            if (data.companyCode) payload.companyCode = data.companyCode
            userLogin(payload).then(
                res => {
                    resolve(res);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    // 首页信息
    pageInfo({ commit }, data = {}) {
        return new Promise((resolve, reject) => {
            accountInfo({ local: Cookies.get('language') })
                .then(response => {
                    const { result } = response;
                    if (!result) {
                        reject('用户信息解析错误');
                    }
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // 存储树形数据
    getTreeData({ commit, state }, data = {}) {
        return new Promise((resolve, reject) => {
            shareTree(data)
                .then(response => {
                    const { result } = response;
                    if (!result) {
                        reject('用户信息解析错误');
                    }
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    actions
};
